import React from 'react';
import { PropTypes } from 'prop-types';

export const getSingleCheckboxState = name => value => document
  .querySelector(`input[type="checkbox"][name="${ name }"]`)
  .checked;

export const getCheckboxValue = name => value => Array
  .from(document.querySelectorAll(`input[type="checkbox"][name="${ name }"]`))
  .filter(el => el.checked)
  .map(el => el != null && el.value);

const isCheckboxChecked = (
  modelValue,
  inputValue
) => (
  (modelValue
    && modelValue.length
    && typeof modelValue !== 'string'
    && modelValue.indexOf(inputValue) !== -1)
  || (modelValue
    && modelValue.length
    && typeof modelValue === 'string' && modelValue === inputValue)
  || (modelValue === true
    && inputValue === 'true')
  || (modelValue === false
    && inputValue === 'false')
);

const CheckboxInput = ({
  input,
  meta: {
    touched,
    error
  },
  item,
  iValue,
  id,
  className }) => (
    // eslint-disable-next-line jsx-a11y/label-has-for
    <label className="form-checkbox" id={ id }>
      <input
        type="checkbox"
        { ...input }
        value={ iValue }
        checked={ isCheckboxChecked(input.value, iValue) }
        id={ `${ id }-value` }
      />
      <i
        className={ `form-icon ${ className } ${ touched && error && 'is-error' }` }
        id={ `${ id }-icon` }
      />
      { item }
    </label>
);

CheckboxInput.propTypes = {
  className: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ])
  }).isRequired,
  item: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  iValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }),
  id: PropTypes.string,
};

CheckboxInput.defaultProps = {
  item: null,
  className: null,
  id: null,
  meta: { touched: false, error: false }
};

export default CheckboxInput;
